import * as yup from 'yup';

yup.addMethod(yup.string, 'select', function () {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && field.value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  device: yup.string().select(),
  expedient: yup.string().select(),
  logged: yup.bool(),
  groupMembers: yup.array()
});

export default schema;
